// src/theme/atomic/orange.ts
var orange = {
  10: "#361E00",
  20: "#663A00",
  30: "#9C5800",
  40: "#D47800",
  50: "#FF9200",
  60: "#FFA938",
  70: "#FFC06E",
  80: "#FFD49C",
  90: "#FEE6C6",
  95: "#FEF4E6",
  99: "#FFFCF7"
};
var orange_default = orange;

export { orange_default as default };
